const ICON_RULES = [
  { keywords: ['boek', 'bijbel', 'bible'], icon: '📚' },
  { keywords: ['kleding', 'shirt', 'hoodie', 'merchandise', 'merch', 'mok', 'mug'], icon: '👕' },
  { keywords: ['muziek', 'worship', 'opwekking', 'cd', 'lied'], icon: '🎵' },
  { keywords: ['ticket', 'conferentie', 'kamp', 'event', 'seminar'], icon: '🎟️' },
  { keywords: ['donatie', 'gift', 'geven', 'zending'], icon: '❤️' },
  { keywords: ['koffie', 'thee'], icon: '☕' },
  { keywords: ['jeugd', 'kind', 'kinderwerk'], icon: '🎒' },
  { keywords: ['cadeau', 'giftbox'], icon: '🎁' },
];

export const getCategoryIcon = (name = '') => {
  const lower = name.toLowerCase();
  const match = ICON_RULES.find((rule) => rule.keywords.some((keyword) => lower.includes(keyword)));
  return match ? match.icon : '🛍️';
};
